import { render, staticRenderFns } from "./PopupRiskInfoEp2.vue?vue&type=template&id=0a64c2f5&scoped=true"
import script from "./PopupRiskInfoEp2.vue?vue&type=script&lang=js"
export * from "./PopupRiskInfoEp2.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskInfoEp2.vue?vue&type=style&index=0&id=0a64c2f5&prod&lang=scss&scoped=true"
import style1 from "./PopupRiskInfoEp2.vue?vue&type=style&index=1&id=0a64c2f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a64c2f5",
  null
  
)

export default component.exports